/**
 * Onboarding step 3 (Company Essentials) write path.
 *
 * `persistEssentials` is the essentials-named entry point onto the generic
 * `updateMyStartupProfile` seam (src/lib/startup/my-startup-profile.ts): resolve
 * the caller's startup via `team_members` (NOT the legacy
 * `startup_profiles.user_id`, which is NULL for every create-path founder) and
 * update by primary key, asserting rows-affected so a zero-row write becomes a
 * surfaced error instead of a silent success. Guarded by
 * src/lib/startup/__tests__/persist-essentials.test.ts.
 */

export { updateMyStartupProfile as persistEssentials } from './my-startup-profile';
